import React, {
  createContext,
  useReducer,
  useContext,
  useState,
  useMemo,
} from 'react';

import PropTypes from 'prop-types';

const StateContext = createContext();
const DispatchContext = createContext();
const StreamingContext = createContext();

const initialState = {
  totalTokens: 0,
  tokensLastHour: 0,
  messagesLastThreeHours: 0,
  chatLogs: [],
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'SET_TOTAL_TOKENS':
      return { ...state, totalTokens: action.payload };
    case 'SET_TOKENS_LAST_HOUR':
      return { ...state, tokensLastHour: action.payload };
    case 'SET_MESSAGES_LAST_THREE_HOURS':
      return { ...state, messagesLastThreeHours: action.payload };
    case 'SET_CHAT_LOGS':
      return { ...state, chatLogs: action.payload };
    default:
      throw new Error(`Unknown action: ${action.type}`);
  }
};

export const AppProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const [isStreamingEnabled, setIsStreamingEnabled] = useState(false);

  const streamingValue = useMemo(() => ({
    isStreamingEnabled,
    setIsStreamingEnabled,
  }), [isStreamingEnabled, setIsStreamingEnabled]);

  return (
    <DispatchContext.Provider value={dispatch}>
      <StateContext.Provider value={state}>
        {/* Include the new StreamingContext.Provider */}
        <StreamingContext.Provider value={streamingValue}>
          {children}
        </StreamingContext.Provider>
      </StateContext.Provider>
    </DispatchContext.Provider>
  );
};

AppProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useAppState = () => useContext(StateContext);
export const useAppDispatch = () => useContext(DispatchContext);
// Export new hook for streaming state
export const useStreamingState = () => useContext(StreamingContext);
